// tslint:disable: completed-docs
const NAMESPACE = 'OVERLAY';
export default NAMESPACE;
export const SET_TRACKING_STATE = 'overlayState';

export const GET_OVERLAY_CONTENT_FAILED = `${NAMESPACE}/GET_OVERLAY_CONTENT_FAILED` as const;
export const PRELOAD_GIGAKOMBI_OVERLAY = `${NAMESPACE}/PRELOAD_GIGAKOMBI_OVERLAY` as const;
export const TRACK_OVERLAY = `${NAMESPACE}/TRACK_OVERLAY` as const;
export const OVERLAY_LOADED = `${NAMESPACE}/OVERLAY_LOADED` as const;

export const INSURANCE_ACCORDION = 'faq-versicherung-accordion-container';
export const TRADEIN_ACCODRION = 'tradein-accordion-container';
export const TAUSCHBONUS_ACCORDION = 'tauschbonus-accordion-container';
export const OVERLAY_GIGAKOMBI_CONTAINER_ID = 'gigakombi-overlay-container';

export const GIGAKOMBI_OVERLAY_NAME = 'gigakombi-login';
export const INSURANCE_OVERLAY_NAME = 'overlay-phone-insurance';
export const TRADE_IN_OVERLAY_NAME = 'overlay-trade-in';
export const TAUSCHBONUS_OVERLAY_NAME = 'overlay-tauschbonus';

export const USER_COOKIE_KEY = 'MDDKeks';
